import BadRequestErrorResponse from "./responses/BadRequestErrorResponse";
import ForbiddenErrorResponse from "./responses/ForbiddenErrorResponse";
import InternalServerErrorResponse from "./responses/InternalServerErrorResponse";
import NotFoundErrorResponse from "./responses/NotFoundErrorResponse";
import { ContextualError } from "@lib/utils/ContextualError";
import type { Middleware } from "openapi-fetch";

async function parseResponseJson(response: Response): Promise<unknown> {
  const contentType = response.headers.get("content-type");
  if (contentType?.includes("application/json")) {
    return response.json();
  }

  const body = await response.text().catch(() => "<unreadable>");
  throw new ContextualError("Response is not JSON", {
    url: response.url,
    status: response.status,
    contentType,
    body
  });
}

const errorMiddleware: Middleware = {
  onResponse: async ({ request, response }) => {
    if (!response.ok) {
      const json = await parseResponseJson(response);

      switch (response.status) {
        case 400:
          throw new BadRequestErrorResponse(response, json);
        case 401:
          window.history.pushState({}, "", "/logout");
          break;
        case 403:
          throw new ForbiddenErrorResponse(response);
        case 404:
          throw new NotFoundErrorResponse(response);
        case 500:
          throw new InternalServerErrorResponse(request, response);
        default: {
          const errorMessage = `Unexpected error response: ${response.status}`;
          console.error(`Unexpected error response: ${response.status}`, response);
          throw new Error(errorMessage);
        }
      }
    }
  }
};

export default errorMiddleware;
